import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const euroFormatter = new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" });

/** Prezzo in formato italiano: 10,00 € */
export function formatEuro(value: number) {
  return euroFormatter.format(Number(value) || 0);
}
